import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  chapter: string;
  tag: string;
  tagColor: 'primary' | 'accent' | 'secondary';
  image: string;
}

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50 dark:text-foreground-950',
  secondary: 'bg-secondary-500 text-background-50 dark:text-foreground-950',
};

export default function ComicCard({ id, title, chapter, tag, tagColor, image }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
        <img
          src={image}
          alt={title}
          title={`好看的韩国漫画 - ${title}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        <span
          className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold ${tagColorMap[tagColor]}`}
        >
          {tag}
        </span>
      </div>
      <div className="mt-3 px-1">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-500">{chapter}</p>
      </div>
    </Link>
  );
}